<div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">

    <div class="flex flex-col ">
        <label class="font-bold">Titolo</label>
        <input pInputText type="text" 
                [ngModel]="filter().shortDescription" 
                (ngModelChange)="onFieldChange('shortDescription', $event)"
                placeholder="Cerca..." class="w-full" />
    </div>
    <div class="flex flex-col ">
        <label class="font-bold">Descrizione</label>
        <input pInputText type="text" 
                [ngModel]="filter().description" 
                (ngModelChange)="onFieldChange('description', $event)"
                placeholder="Cerca..." class="w-full" />
    </div>

    <div class="flex flex-col ">
        <label class="font-bold">Tipo Operazione</label>
        <p-select [options]="tradeTypes" 
                [ngModel]="filter().finTradeTypeId" 
                (ngModelChange)="onFieldChange('finTradeTypeId', $event)"
                placeholder="Seleaziona tipo operazione" [showClear]="true"></p-select>
    </div>

    <div class="flex flex-col ">
        <label class="font-bold">Wallet</label>
        <p-select [options]="wallets()" 
            [ngModel]="filter().finWalletId" 
            (ngModelChange)="onFieldChange('finWalletId', $event)"
            placeholder="Seleziona wallet" 
            optionLabel="shortDescription"
            optionValue="finWalletId" [showClear]="true"></p-select>
    </div>

    <div class="flex flex-col ">
        <label class="font-bold">Etichetta</label>
        <p-select [options]="etiquettes()" 
            [ngModel]="filter().etiquetteId" 
            (ngModelChange)="onFieldChange('etiquetteId', $event)"
            placeholder="Seleziona etichetta" 
            optionLabel="shortDescription"
            optionValue="etiquetteId" [showClear]="true"></p-select>
    </div>

    <div class="flex flex-col ">
        <label class="font-bold">Mese</label>
        <p-select [options]="monthsList" 
                [ngModel]="filter().accountingMonth" 
                (ngModelChange)="onFieldChange('accountingMonth', $event)"
                placeholder="Seleziona Mese" [showClear]="true"></p-select>
    </div>

</div>
